import axios from "./axios";
import { getServerAPIBaseURL } from "../config/server";
// Set base url for axios request
axios.defaults.baseURL = getServerAPIBaseURL();
export * from "./firebase";
export * from "./common";
export * from "./waitlist";
export * from "./user";
export * from "./auth";
export * from "./plan";
export * from "./type";
